import { observer } from 'mobx-react';

import { SIZE_LARGE, SIZE_MEDIUM } from '@/common/components/Label/Label';
import DriveContainerAccessStatus from '@/drive/components/DriveAccessStatus/DriveContainerAccessStatus/DriveContainerAccessStatus';
import DriveEntityAccessStatus from '@/drive/components/DriveAccessStatus/DriveEntityAccessStatus/DriveEntityAccessStatus';
import { CarbonProjectItem } from '@/drive/entities/DriveItem/CarbonProjectItem';
import { CollectionItem } from '@/drive/entities/DriveItem/CollectionItem';
import { DriveItem } from '@/drive/entities/DriveItem/DriveItem';
import { FolderItem } from '@/drive/entities/DriveItem/FolderItem';
import { ProductItem } from '@/drive/entities/DriveItem/ProductItem';
import { CollectionTreeItem } from '@/drive/entities/DriveTreeItem/CollectionTreeItem';
import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import { FolderTreeItem } from '@/drive/entities/DriveTreeItem/FolderTreeItem';

export interface DriveAccessStatusProps {
  item?: Nullable<DriveItem | DriveTreeItem>;
  size?: typeof SIZE_MEDIUM | typeof SIZE_LARGE;
  isCreatable?: boolean;
  className?: string;
  shouldHidePrivate?: boolean;
  onUpdate?: () => void;
}

function DriveAccessStatus(props: DriveAccessStatusProps) {
  const { item, size, isCreatable, className, shouldHidePrivate, onUpdate } = props;

  const isTreeItem = item instanceof FolderTreeItem || item instanceof CollectionTreeItem;
  const driveItem = isTreeItem ? item.toDriveItem() : item;

  if (driveItem instanceof FolderItem || driveItem instanceof CollectionItem) {
    return (
      <DriveContainerAccessStatus
        item={driveItem}
        size={size}
        isCreatable={isCreatable}
        className={className}
        shouldHidePrivate={shouldHidePrivate}
        onUpdate={onUpdate}
      />
    );
  }

  if (driveItem instanceof ProductItem || driveItem instanceof CarbonProjectItem) {
    return (
      <DriveEntityAccessStatus
        item={driveItem}
        size={size}
        isCreatable={isCreatable}
        className={className}
        shouldHidePrivate={shouldHidePrivate}
        onUpdate={onUpdate}
      />
    );
  }

  return null;
}

export default observer(DriveAccessStatus);
